import styled from "styled-components";

// just a div, for when content will definitely overflow in the y axis
// leaving empty in case need for css arrises
const StretchedContainer = styled.div``;

export default StretchedContainer;
